import { LlmMessage } from '~/atoms/schemas/workflowSchemas';
import { ProcessedEvent } from '../types';
import { getEventNameFromMessageType } from './getEventNameFromMessageType';

// Process LLM messages into ProcessedEvents

export const processLlmMessages = (
  messages: LlmMessage[],
): ProcessedEvent[] => {
  // Group messages by workflow_id, task_id, index
  const messageMap = messages.reduce((acc, message) => {
    if (message.index !== undefined) {
      const key = `${message.workflow_id}-${message.task_id}-${message.index}`;
      if (!acc.has(key)) {
        acc.set(key, message);
      }
    }
    return acc;
  }, new Map<string, LlmMessage>());

  // Convert to processed events
  return Array.from(messageMap.values())
    .map((message) => {
      // Determine event type from the message type
      const eventName = getEventNameFromMessageType(message.type);

      return {
        uuid_run: `${message.run_id}-${message.task_id}-${message.index}`, // Include type in ID to ensure uniqueness
        index: message.index,
        eventName,
        content: message.content,
        timestamp: message.timestamp,
        isComplete: true,
        // Store workflow_id and task_id for reference
        workflow_id: message.workflow_id,
        task_id: message.task_id,
        messageType: message.type,
      };
    })
    .sort((a, b) => {
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    });
};
